import React from 'react';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Typography,
  Card,
  styled,
  CardContent,
  StepConnector,
  stepConnectorClasses
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const steps = ['Initiated', 'Pending', 'Success'];
const getStepIcon = (step, activeStep) => {
  const iconStyle = { color: '#fff' };

  if (step < activeStep) {
    return <CheckCircleIcon sx={iconStyle} />;
  } else if (step === activeStep) {
    return <HourglassEmptyIcon sx={iconStyle} />;
  } else {
    return <RadioButtonUncheckedIcon sx={iconStyle} />;
  }
};

const WhiteConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#fff',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#fff',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#fff',
    borderTopWidth: 2,
    borderRadius: 1,
  },
}));

const StatusProgressCard = ({ activeStep }) => {
  return (
    <Card
      sx={{
        background: 'linear-gradient(135deg, #ff6a6a 0%, #ffbb3b 100%)',
        color: '#fff',
        borderRadius: 3,
        width: 350,
        padding: 2,
        boxShadow: '0 6px 15px rgba(88, 86, 214, 0.5)',
      }}
    >
      <CardContent>
        <Box sx={{ width: '100%' }}>
          <Stepper
            alternativeLabel
            activeStep={activeStep}
            connector={<WhiteConnector />}
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel
                  icon={getStepIcon(index, activeStep)}
                  sx={{
                    '& .MuiStepLabel-label': {
                      color: '#fff',
                      fontWeight: 'bold',
                    },
                    '& .MuiStepLabel-iconContainer': {
                      color: '#fff',
                    },
                  }}
                >
                  <Typography style={{ fontSize: '14px', fontWeight: 'bold' }} variant="body2">
                    {label}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatusProgressCard;
